<template>
  <div class="p">
    <h2>Agent Login</h2>

    <div class="box">
      <input v-model="username" placeholder="username" />
      <input v-model="password" type="password" placeholder="password" />
      <button @click="login" :disabled="loading">
        {{ loading ? "Loading..." : "Login" }}
      </button>
      <p v-if="err" class="err">{{ err }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { auth } from "@/services/auth";
import { useAgentSocket } from "@/services/socket";

const router = useRouter();
const username = ref("agent1");
const password = ref("123");
const loading = ref(false);
const err = ref("");

const { connect } = useAgentSocket();

async function login() {
  loading.value = true;
  err.value = "";

  try {
    const r = await fetch("https://sudarshan.fonetricks.com/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: username.value, password: password.value }),
    });

    const data = await r.json();
    if (!data.ok) {
      err.value = data.message || "Login failed";
      return;
    }

    auth.token = data.token;
    auth.user = data.user;

    connect(); // connect socket after login

    if (data.user.role === "manager" || data.user.role === "admin") {
      router.push("/manager");
    } else {
      router.push("/inbox");
    }
    
  } catch (e) {
    err.value = "Network error";
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.p { max-width: 420px; margin: 60px auto; font-family: Arial; }
.box { display: grid; gap: 10px; padding: 16px; border: 1px solid #ddd; border-radius: 10px; }
input { padding: 10px; border: 1px solid #ccc; border-radius: 8px; }
button { padding: 10px; border: none; border-radius: 8px; background: #0b66d1; color: #fff; cursor: pointer; }
.err { color: #e74c3c; margin: 0; }
</style>